module.exports = __webpack_public_path__ + "static/media/dots-horizontal-triple.c5b6fe39.svg";